import { useLocalization } from "../../../contexts/Localization";
import * as React from "react";
import S from "./TopMenu.styled";
import { Link } from "gatsby";

interface Props {
    phoneNumber: string;
    email: string;
    link: string;
    linkText: string;
}

type language = {
    flag: string;
    name: string;
    url: string;
}

type languageArray = {
    [key:string]: language;
}

const TopMenu: React.FC<Props> = ({phoneNumber, email, link, linkText}) => {

    const { language, translations } = useLocalization();

    const languages = {
        sv: {
            flag: "swedish.png",
            name: "Svenska",
            url: '/'
        },
        en: {
            flag: "english.png",
            name: "English",
            url: '/en'
        },
        zh: {
            flag: "mandarin.png",
            name: "中国人",
            url: '/zh'
        }
    }

    var availableLanguages:languageArray = {};

    translations.forEach(element => {
        availableLanguages[element.language.slug] = languages[element.language.slug];
        availableLanguages[element.language.slug].url = element.uri;
    });

    const currentLanguage = languages[language];
    availableLanguages[language] = currentLanguage;

    return (
        <S.mTopMenu id="headerTopMenu" className={"relative hidden md:flex flex-row items-center sm:h-8 justify-between bg-metlab-200 text-metlab-700 text-sm"}>
            <div className="relative max-w-7xl pt-4 pb-4 sm:px-6 w-full mx-auto flex items-center justify-between">
            <div className="relative max-w-7xl pt-4 pb-4 w-full mx-auto flex items-center justify-start">
                <b><a href="tel:+46101550561"><i className='bx bx-phone-call'></i> {phoneNumber}</a></b>
                <b><a href={"mailto:"+email}><i className='bx bx-paper-plane' ></i> {email}</a></b>
            </div>
            <div className="relative max-w-7xl pt-4 pb-4 w-full mx-auto flex items-center justify-end">
                <a href={link} target="_blank" rel="noopener"><b>{linkText}</b></a>
                <S.Dropdown className={"inline-block relative"}>

                <button className="text-metlab-700 px-4 rounded inline-flex items-center">
                    <span className="mr-1" style={{marginTop: "5px"}}><img src={'/'+currentLanguage.flag} style={{height: "20px", width: "20px"}} /></span>
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
                </button>
                <S.dropdownMenu className={"absolute right-0 hidden text-gray-700 pt-1 shadow-lg bg-white"}>
                    {Object.entries(availableLanguages).map(([key, lang]) => (
                        <Link key={key} to={lang.url} className="flex items-center bg-white hover:bg-gray-100 py-4 px-6 whitespace-no-wrap text-sm">
                            <img src={'/'+lang.flag} style={{height: "20px", width: "20px", objectFit: "contain"}} /> {lang.name}
                        </Link>
                    ))}
                </S.dropdownMenu>

                </S.Dropdown>

            </div>
            </div>
        </S.mTopMenu>
    )
};
export default TopMenu;